import * as React from 'react'
import { tw } from 'utils/classnames'
import { SearchIcon } from 'primitives/icons'

export interface SearchInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onSearch?: () => void
  classNameInput?: string
}

export const SearchInput = ({
  ref,
  value,
  onChange,
  onSearch,
  placeholder = 'Search...',
  onKeyDown,
  className,
  classNameInput,
  ...props
}: SearchInputProps & {
  ref?: React.RefObject<HTMLInputElement | null>
}) => {
  const inputRef = React.useRef<HTMLInputElement>(null)
  React.useImperativeHandle(ref, () => inputRef.current as HTMLInputElement)

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (onKeyDown) {
      onKeyDown(e)
    }
    if (e.key === 'Enter' && onSearch) {
      onSearch()
    }
  }

  return (
    <div
      className={tw(
        'relative flex w-full flex-col border border-cf-grey-200 bg-cf-grey-50 rounded-[6px]',
        className,
      )}
    >
      <div className="relative flex w-full items-center">
        <input
          ref={inputRef}
          value={value}
          onChange={onChange}
          className={tw(
            'placeholder-transition h-[40px] w-full px-5 py-[10px] pr-10 text-cf-grey-1000 placeholder:text-cf-grey-400 focus:outline-none caret-cf-grey-500 bg-transparent',
            classNameInput,
          )}
          type="text"
          placeholder={placeholder}
          onKeyDown={handleKeyDown}
          {...props}
        />
        <div
          onClick={onSearch}
          className="absolute inset-y-0 right-0 flex cursor-pointer items-center pr-3 text-gray-200"
          tabIndex={0}
          role="button"
          aria-label="search"
          onKeyDown={e => {
            if (e.key === 'Enter' && onSearch) {
              onSearch()
            }
          }}
        >
          <SearchIcon aria-label="search" className="size-4" />
        </div>
      </div>
    </div>
  )
}

SearchInput.displayName = 'SearchInput'
